const IT_SUPPORT = [{
  label: 'Incident',
  value: 1,
  key: 1,
  icon: 'BugFilled', // Closely maps to unexpected issue or error
  color: '#c62828',
  background: 'rgba(255,171,145,0.16)'
}, {
  label: 'Service Request',
  value: 2,
  key: 2,
  icon: 'TaskFilled', // Task-like service delivery
  color: '#1976d2',
  background: 'rgba(144,202,249,0.16)'
}, {
  label: 'Problem',
  value: 3,
  key: 3,
  icon: 'ChangerequestFilled', // Request to resolve deeper/root issues
  color: '#f57c00',
  background: 'rgba(255,224,178,0.16)'
}, {
  label: 'Change',
  value: 4,
  key: 4,
  icon: 'FeatureRequestFilled', // Intentional planned change
  color: '#6a1b9a',
  background: 'rgba(209,196,233,0.16)'
}, {
  label: 'Access Request',
  value: 5,
  key: 5,
  icon: 'SubtaskFilled', // Smaller operational request
  color: '#2e7d32',
  background: 'rgba(165,214,167,0.16)'
}, {
  label: 'Outage',
  value: 6,
  key: 6,
  icon: 'StoryFilled', // Represents timeline/status view
  color: '#d84315',
  background: 'rgba(255,204,188,0.16)'
}, {
  label: 'Maintenance',
  value: 7,
  key: 7,
  icon: 'ImprovementsFilled', // Maintenance = ongoing improvement
  color: '#fb8c00',
  background: 'rgba(255,224,178,0.16)'
}, {
  label: 'Security Alert',
  value: 8,
  key: 8,
  icon: 'EpicFilled', // Major, high-priority alert
  color: '#8e24aa',
  background: 'rgba(225,190,231,0.16)'
}, {
  label: 'General Inquiry',
  value: 9,
  key: 9,
  icon: 'SupportFilled', // General questions go to support
  color: '#455a64',
  background: 'rgba(176,190,197,0.16)'
}];

export { IT_SUPPORT };
